import type { ReduxRootState } from 'types';

interface Params {
  messages: ReduxRootState['messages'];
}

const getCustomAttributesTypes = ({ messages }: Params) => ({
  String: messages.attributesTypeString,
  StringWithOptions: messages.attributesTypeStringWithOptions,
  Text: messages.attributesTypeText,
  Number: messages.attributesTypeNumber,
  Boolean: messages.attributesTypeBoolean,
  Array: messages.attributesTypeArray,
  ArrayWithOptions: messages.attributesTypeArrayWithOptions
});

export default getCustomAttributesTypes;
